<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import localforage from "localforage";
import { useMyInfoStore } from "~/stores/MyInfoStore";

const myInfoStore = useMyInfoStore();
const route = useRoute();
const router = useRouter();
const shortcode = route.params.shortcode;

onMounted(async () => {
  localforage.setItem("shortcode", shortcode);

  if (shortcode) {
    await myInfoStore.load();
  }

  if (myInfoStore.userInfo) {
    router.push("/main-dashboard");
  } else {
    router.push("/landing");
  }
});
</script>
<template>
  <div></div>
</template>
